import React from 'react';
const IconPersonGroupFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.6998 13H13.1198L10.5698 20H19.0298L18.2998 18H15.5198L16.2498 16H19.6998L21.1498 20H23.2498L20.6998 13Z" fill="#2D2E2E"/>
<path d="M3.3 13L0.75 20H8.41L10.96 13H3.3Z" fill="#2D2E2E"/>
<path d="M7.5 11.5C9.70914 11.5 11.5 9.70914 11.5 7.5C11.5 5.29086 9.70914 3.5 7.5 3.5C5.29086 3.5 3.5 5.29086 3.5 7.5C3.5 9.70914 5.29086 11.5 7.5 11.5Z" fill="#2D2E2E"/>
<path d="M17 11.5C19.2091 11.5 21 9.70914 21 7.5C21 5.29086 19.2091 3.5 17 3.5C14.7909 3.5 13 5.29086 13 7.5C13 9.70914 14.7909 11.5 17 11.5Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconPersonGroupFill;